// Function to aggregate data based on specified fields
//
// `aggregateBy` is one [sourceField, targetField] pair, or a list of them when
// the buckets are keyed by more than one field — an expense posts once per VAT
// code AND expense account, so its posting groups are keyed by both.
function aggregate(data, aggregateBy, sumFields, transferFields) {
    const aggregatedData = {};
    const keys = Array.isArray(aggregateBy[0]) ? aggregateBy : [aggregateBy];

    data.forEach(item => {
        // Get the key to aggregate by
        const agKey = keys.length === 1
            ? item[keys[0][0]]
            : JSON.stringify(keys.map(([source]) => item[source] ?? null));

        if (!aggregatedData[agKey]) {
            // If this key doesn't exist yet, create a new entry
            aggregatedData[agKey] = Object.fromEntries(keys.map(([source, target]) => [target, item[source]]));
            
            // Initialize sum fields
            sumFields.forEach(field => {
                aggregatedData[agKey][field[1]] = item[field[0]];
            });
            
            // Transfer fields that don't need to be summed
            transferFields.forEach(field => {
                aggregatedData[agKey][field[1]] = item[field[0]];
            });
        } else {
            // If the key already exists, sum the specified fields
            sumFields.forEach(field => {
                aggregatedData[agKey][field[1]] += item[field[0]];
            });
        }
    });

    // Convert the aggregated data object to an array
    return Object.values(aggregatedData);
}

// Main function to perform sub-aggregation
const subAggregate = (data, operation) => {
    // Get the object to aggregate from the data
    const objectToRead = data[operation.entityToAggregate] || [];
    if (!Array.isArray(objectToRead)) {
        console.warn(`Data for ${operation.entityToAggregate} is not an array. Skipping aggregation.`);
        return data;
    }

    // Perform the aggregation
    const aggregatedObject = aggregate(
        objectToRead, 
        operation.aggregateBy, 
        operation.sumFields, 
        operation.transferFields
    );

    // Return new object with the aggregated data instead of mutating
    return {
        ...data,
        [operation.targetEntity]: aggregatedObject
    };
}

export default subAggregate;
